import React from 'react';

const TileGridHeader = ({ title, viewAllText, onViewAllClick, style }) => {
  if (!title) return null;

  return (
    <div className='tile-grid-header' style={style}>
      <h2 className='tile-grid-title'>{title}</h2>
      {viewAllText && (
        <button className='view-all-link' onClick={onViewAllClick} type='button'>
          {viewAllText}
        </button>
      )}
    </div>
  );
};

export default TileGridHeader;
